export const getTheme = state => state.theme.value;
